import Button from "../base/Button";

const renderIcon = (color) => (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
        <title>filter</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Symbols---Zep"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
        >
            <g
                id="LS-Menu"
                transform="translate(-365.000000, -14.000000)"
                stroke={color}
            >
                <g id="filter">
                    <g transform="translate(365.000000, 14.000000)">
                        <polygon
                            id="Shape"
                            points="0.761904762 0.761904762 31.2380952 0.761904762 19.047619 19.047619 19.047619 31.2380952 12.952381 31.2380952 12.952381 19.047619"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

/**
 * Toolbar button for the filter tool.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered filter button.
 */
const FilterButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default FilterButton;
